/**
 * @file Generated by js-routes 2.3.5. Based on Rails 8.0.1 routes of Trinity::Application.
 * @version 9f268601d25191c5b15f35a95e6b7feac74da2a0d2e0f4ac0f5ea3f2bc6a48fc
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /st/smart_suggestions/:id/apply(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apply_st_smart_suggestion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"smart_suggestions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/conversations/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_st_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/drafts/:id/auto_save(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_save_st_draft_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"auto_save"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ca/chatbots/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ca_chatbot_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"ca"],[2,[7,"/"],[2,[6,"chatbots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ca/chatbots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ca_chatbots_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"ca"],[2,[7,"/"],[2,[6,"chatbots"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ca(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ca_home_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"ca"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings/st/channels/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callback_settings_st_channels_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/drafts/:id/cancel_send(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_send_st_draft_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/drafts/compose/inbox/:inbox_id(.:format)
 * @param {any} inbox_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compose_st_drafts_path = /*#__PURE__*/ __jsr.r({"inbox_id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[6,"compose"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"inbox_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /debug(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"debug"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /debug/failed_executions/:id/discard(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_discard_failed_execution_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"debug"],[2,[7,"/"],[2,[6,"failed_executions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /debug/failed_executions/:id/download_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_download_email_of_failed_execution_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"debug"],[2,[7,"/"],[2,[6,"failed_executions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/messages/:id/debug_download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_download_st_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"debug_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/messages/:id/debug_reanalyze(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_reanalyze_st_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"debug_reanalyze"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/st/channels/:id/debug_refresh_watch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_refresh_watch_settings_st_channel_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"debug_refresh_watch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/messages/:id/debug_regenerate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_regenerate_st_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"debug_regenerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /debug/failed_executions/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_retry_failed_execution_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"debug"],[2,[7,"/"],[2,[6,"failed_executions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/conversations/:id/debug_upload_eml(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_upload_eml_st_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"debug_upload_eml"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/smart_suggestions/:id/dismiss(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dismiss_st_smart_suggestion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"smart_suggestions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dismiss"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ca/chatbots/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ca_chatbot_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"ca"],[2,[7,"/"],[2,[6,"chatbots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /kb/knowledge_bases/:knowledge_base_id/articles/:id/edit(.:format)
 * @param {any} knowledge_base_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_kb_knowledge_base_article_path = /*#__PURE__*/ __jsr.r({"knowledge_base_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[2,[7,"/"],[2,[3,"knowledge_base_id"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /kb/knowledge_bases/:knowledge_base_id/categories/:id/edit(.:format)
 * @param {any} knowledge_base_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_kb_knowledge_base_category_path = /*#__PURE__*/ __jsr.r({"knowledge_base_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[2,[7,"/"],[2,[3,"knowledge_base_id"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/ai/assistants/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_ai_assistant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"assistants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/kb/knowledge_bases/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_kb_knowledge_base_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/st/custom_actions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_st_custom_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"custom_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/st/inboxes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_st_inbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"inboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/drafts/:id/generate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_st_draft_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /health_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"health_status"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /health_status/ping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_status_ping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"health_status"],[2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /kb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kb_home_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"kb"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /kb/knowledge_bases/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kb_knowledge_base_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /kb/knowledge_bases/:knowledge_base_id/articles/:id(.:format)
 * @param {any} knowledge_base_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kb_knowledge_base_article_path = /*#__PURE__*/ __jsr.r({"knowledge_base_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[2,[7,"/"],[2,[3,"knowledge_base_id"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /kb/knowledge_bases/:knowledge_base_id/articles(.:format)
 * @param {any} knowledge_base_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kb_knowledge_base_articles_path = /*#__PURE__*/ __jsr.r({"knowledge_base_id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[2,[7,"/"],[2,[3,"knowledge_base_id"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /kb/knowledge_bases/:knowledge_base_id/categories(.:format)
 * @param {any} knowledge_base_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kb_knowledge_base_categories_path = /*#__PURE__*/ __jsr.r({"knowledge_base_id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[2,[7,"/"],[2,[3,"knowledge_base_id"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /kb/knowledge_bases/:knowledge_base_id/categories/:id(.:format)
 * @param {any} knowledge_base_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kb_knowledge_base_category_path = /*#__PURE__*/ __jsr.r({"knowledge_base_id":{"r":true},"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[2,[7,"/"],[2,[3,"knowledge_base_id"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ca/chatbots/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ca_chatbot_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"ca"],[2,[7,"/"],[2,[6,"chatbots"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /kb/knowledge_bases/:knowledge_base_id/articles/new(.:format)
 * @param {any} knowledge_base_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_kb_knowledge_base_article_path = /*#__PURE__*/ __jsr.r({"knowledge_base_id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[2,[7,"/"],[2,[3,"knowledge_base_id"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /kb/knowledge_bases/:knowledge_base_id/categories/new(.:format)
 * @param {any} knowledge_base_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_kb_knowledge_base_category_path = /*#__PURE__*/ __jsr.r({"knowledge_base_id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[2,[7,"/"],[2,[3,"knowledge_base_id"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/st/channels/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_settings_st_channel_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/conversations/:id/custom_action/:custom_action_id/perform(.:format)
 * @param {any} id
 * @param {any} custom_action_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const perform_custom_action_st_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"custom_action_id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom_action"],[2,[7,"/"],[2,[3,"custom_action_id"],[2,[7,"/"],[2,[6,"perform"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ca/widget/:widget_id/chat/ask(.:format)
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_ca_ask_chat_path = /*#__PURE__*/ __jsr.r({"widget_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ca"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"widget_id"],[2,[7,"/"],[2,[6,"chat"],[2,[7,"/"],[2,[6,"ask"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ca/widget/:widget_id(.:format)
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_ca_chat_widget_path = /*#__PURE__*/ __jsr.r({"widget_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ca"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"widget_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ca/widget/:widget_id/contact_us(.:format)
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_ca_contact_us_path = /*#__PURE__*/ __jsr.r({"widget_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ca"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"widget_id"],[2,[7,"/"],[2,[6,"contact_us"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ca/widget/:widget_id/chat(.:format)
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_ca_get_chat_path = /*#__PURE__*/ __jsr.r({"widget_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ca"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"widget_id"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /public/ca/widget/:widget_id/chat(.:format)
 * @param {any} widget_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_ca_reset_chat_path = /*#__PURE__*/ __jsr.r({"widget_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"ca"],[2,[7,"/"],[2,[6,"widget"],[2,[7,"/"],[2,[3,"widget_id"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /articles/:id-:slug(.:format)
 * @param {any} id
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_kb_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[6,"-"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /redirect/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_kb_article_slug_redirect_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /categories/:id-:slug(.:format)
 * @param {any} id
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_kb_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[6,"-"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_kb_home_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_properties_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/routes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_routes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/conversations/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_st_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/drafts/reply(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reply_st_drafts_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[6,"reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({"host":{"d":"app.trinity.development"}}, [7,"/"]);

/**
 * Generates rails route to
 * /st/drafts/:id/send_draft(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_draft_st_draft_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings/ai/assistants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_ai_assistant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"assistants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/ai/assistants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_ai_assistants_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ai"],[2,[7,"/"],[2,[6,"assistants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/kb/knowledge_bases/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_kb_knowledge_base_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/kb/knowledge_bases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_kb_knowledge_bases_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"kb"],[2,[7,"/"],[2,[6,"knowledge_bases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/st/channels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_st_channel_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/st/custom_actions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_st_custom_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"custom_actions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/st/custom_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_st_custom_actions_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"custom_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/st/inboxes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_st_inbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"inboxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/st/inboxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_st_inboxes_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"inboxes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /st/conversations/:id/spam(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spam_st_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"spam"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const st_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /st/conversations/:conversation_id(.:format)
 * @param {any} conversation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const st_conversation_path = /*#__PURE__*/ __jsr.r({"conversation_id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /st/conversations/:conversation_id/comments(.:format)
 * @param {any} conversation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const st_conversation_comments_path = /*#__PURE__*/ __jsr.r({"conversation_id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"conversation_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/drafts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const st_draft_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /st/inbox/:inbox_id/status/:status(/conversations/:conversation_id)(.:format)
 * @param {any} inbox_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const st_inbox_path = /*#__PURE__*/ __jsr.r({"inbox_id":{"r":true},"status":{"r":true},"conversation_id":{},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"inbox_id"],[2,[7,"/"],[2,[6,"status"],[2,[7,"/"],[2,[3,"status"],[2,[1,[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[3,"conversation_id"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/open/conversation/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const st_open_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"open"],[2,[7,"/"],[2,[6,"conversation"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/open/message/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const st_open_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"open"],[2,[7,"/"],[2,[6,"message"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/proxy/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const st_proxy_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /st(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const st_root_path = /*#__PURE__*/ __jsr.r({"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /st/search(/conversations/:conversation_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const st_search_path = /*#__PURE__*/ __jsr.r({"conversation_id":{},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"search"],[2,[1,[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[3,"conversation_id"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /st/drafts/:id/take_over(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const take_over_st_draft_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"take_over"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /st/conversations/:id/trash(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trash_st_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"host":{"d":"app.trinity.development"}}, [2,[7,"/"],[2,[6,"st"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trash"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

